export default "__VITE_ASSET__Clp0bgeA__"